import { P00039DataRxTxIndex } from '../../P00039Sync';
import { Pool } from '../../../../../../apis/pool.api';
import { IProduct } from '../../../IProduct';

export function P0003607FunctionReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.ElectrolyseurStandard_Controle,
    'esCResetUsine',
    1,
    null,
    productClass,
  );
}
